import { IGetPaymentCommission } from 'src/store/api/paymentCommission/types';
import { createAction } from '@reduxjs/toolkit';

const setParams = createAction<IGetPaymentCommission['params']>('paymentCommissionsFilters/setParams');
const setBody = createAction<IGetPaymentCommission['data']>('paymentCommissionsFilters/setBody');
const clearCurr = createAction('paymentCommissionsFilters/clearFilters');
const clearBody = createAction('paymentCommissionsFilters/clearBody');

export const paymentCommissionsFiltersActions = {
  clearCurr,
  setParams,
  setBody,
  clearBody,
};
